import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0m-.356 7.111c-2.749 0-4.978 2.13-4.978 4.758 0 1.885 1.146 3.514 2.809 4.284L12.464 25.6h6.361l-1.012-9.447c1.663-.77 2.809-2.399 2.809-4.284 0-2.628-2.229-4.758-4.978-4.758"
    }, null, -1)
  ]))]))
}
export default { render: render }